<script setup>
// FLOW-05 (ajuste da task 5.1) — o selo do editor de flow, sem etiqueta tonal (regra do Murilo,
// 13/10): um glifo pequeno na cor do estado e o texto neutro, sem fundo. O glifo é o ponto do
// estado, como o da fase do teste no painel (`PainelDeTeste.vue`, `situacao.cor`), ou um ícone
// quando o ícone diz mais (o escudo do sandbox, o alfinete do fixado). O texto não quebra: numa
// linha estreita, o selo inteiro desce para a linha de baixo.
defineProps({
  // A cor do glifo, escrita por inteiro (o Tailwind só gera a classe que acha no código): o fundo
  // do ponto (`bg-n-teal-9`) ou a cor do ícone (`text-n-teal-11`).
  cor: { type: String, default: 'bg-n-slate-9' },
  // Um ícone no lugar do ponto (`i-lucide-shield`).
  icone: { type: String, default: null },
});
</script>

<template>
  <span
    class="inline-flex items-center gap-1 whitespace-nowrap text-n-slate-11"
  >
    <span
      v-if="icone"
      class="size-3 shrink-0"
      :class="[icone, cor]"
      aria-hidden="true"
      data-glifo
    />
    <span
      v-else
      class="rounded-full size-1.5 shrink-0"
      :class="cor"
      aria-hidden="true"
      data-glifo
    />
    <slot />
  </span>
</template>
